import { getCurrentFiscalYear, getFiscalYears } from '../../../shared/utils/comptabiliteService';

export const FISCAL_YEAR_REFRESH_EVENT = 'comptabilite:fiscal-years-refresh';

/** Human-readable fiscal year label from API row (year_name or start_date year). */
export function resolveFiscalYearLabel(fy) {
  if (!fy || typeof fy !== 'object') return String(new Date().getFullYear());
  if (fy.year_name) return String(fy.year_name);
  if (fy.start_date) return String(fy.start_date).slice(0, 4);
  return String(new Date().getFullYear());
}

/** Build select options from live fiscal year rows. */
export function buildFiscalYearSelectOptions(years = []) {
  const seen = new Set();
  const options = [];
  for (const fy of years) {
    const label = resolveFiscalYearLabel(fy);
    if (!label || seen.has(label)) continue;
    seen.add(label);
    options.push({ value: label, label });
  }
  return options.sort((a, b) => b.value.localeCompare(a.value, undefined, { numeric: true }));
}

/** Load fiscal year picker options from API (Exercice / Clôture config). */
export async function loadFiscalYearSelectOptions() {
  try {
    const years = await getFiscalYears();
    return buildFiscalYearSelectOptions(Array.isArray(years) ? years : []);
  } catch {
    return [];
  }
}

export function fiscalYearSelectOptionsWithFallback(options = [], currentValue = '') {
  if (options.length) return options;
  const value = String(currentValue || '').trim();
  return value ? [{ value, label: value }] : [];
}

export function dispatchFiscalYearRefresh() {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(FISCAL_YEAR_REFRESH_EVENT));
  }
}

/** Load current fiscal year id + label for comptabilité list/create forms. */
export async function fetchCurrentFiscalYearContext() {
  try {
    const fy = await getCurrentFiscalYear();
    return {
      id: fy?.id || '',
      label: resolveFiscalYearLabel(fy),
      raw: fy || null,
    };
  } catch {
    const label = String(new Date().getFullYear());
    return { id: '', label, raw: null };
  }
}
